<template>
  <div id="app" v-touch="onAppPinch" :class="{'home-active': $route.path.indexOf('info')<0, 'info-active': $route.path.indexOf('info')>0}">

    <!-- <play class="play" :class="{'info-active': $route.path.indexOf('info')>0}"></play> -->

    <router-view class="router-view visual-view" :class="{'info-active': $route.path.indexOf('info')>0}" ></router-view>

    <router-view class="router-view" :class="{'home-active': $route.path.indexOf('info')<0}" name="info"></router-view>

  </div>
</template>

<script>
  // import Play from './components/Play'
  export default {
    name: 'App',
    components: {
      // Play
    },
    methods: {
      onAppPinch () {
        return false
        // console.log('onAppPinch', ev)
      }
    }
  }
</script>

<style lang="scss">
html, body {
  font-family: "ITC Avant Garde Gothic W01", sans-serif;
  // font-family: 'B612 Mono', monospace;
  // font-family: 'B612 Mono', monospace;
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: white;
  font-weight: 600;
  overflow: hidden;
  font-size: 14px;
}
*, *:before, *:after {
  box-sizing: border-box;
}
.noselect {
  touch-action: none;
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
}

a, a:active, a:visited {
  color: #000;
  text-decoration: inherit;
}

.play,
.visual-view {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  z-index: 1;
  transition: .5s all ease;

  &.info-active {
    -webkit-filter: blur(3px);
    // box-shadow: 0px 0px 100px 0px #ff751c inset;
    // transform: scale(1.5);
  }
}
.router-view {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  z-index: 9;

  &.home-active {
    pointer-events: none;
    touch-action: none;
  }
}
//
.fade-enter-active {
  transition: opacity .5s;
  transition-delay: 1s;
}
.fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.quick-fade-enter-active {
  transition: opacity .3s;
  transition-delay: 0s;
}
.quick-fade-leave-active {
  transition: opacity .3s;
}
.quick-fade-enter, .quick-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
